import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Page,
  Left,
  Right,
  HeaderRow,
  RoleListContainer,
  RoleItem,
  SearchInput,
  TreeHeader,
  TreeContainer,
} from "../styles/component.style";

import PermissionNode from "./PermissionNode";
import ModalRole from "../modals/ModalRole";
import useAccessLevels from "../../../../hooks/useAccessLevels";
import { BtnGeneral } from "../../../../styles/Buttons";

export default function AccessLevel() {
  const {
    roles,
    selectedRole,
    search,
    tree,
    checked,
    expanded,

    setSearch,
    toggleModule,
    toggleAction,
    toggleExpand,

    loadRoles,
    loadTree,
    selectRole,
    savePermissions,
    saveRoleData,
  } = useAccessLevels();

  const [openModal, setOpenModal] = useState(false);
  const [editingRole, setEditingRole] = useState(null);

  // Cargar datos iniciales
  useEffect(() => {
    loadRoles();
    loadTree();
  }, []);

  const filteredRoles = roles.filter((r) =>
    r.name.toLowerCase().includes(search.toLowerCase())
  );

  const expandAll = () => {
    tree.forEach((m) => toggleExpand(m.id_modulo, true));
  };

  return (
    <Page>
      {/* PANEL IZQUIERDO */}
      <Left>
        <HeaderRow>
          <h3>Niveles</h3>
          <BtnGeneral
            bg="cyan"
            padding="6px 10px"
            radius="6px"
            fw="600"
            onClick={() => {
              setEditingRole(null);
              setOpenModal(true);
            }}
          >
            Nuevo
          </BtnGeneral>
        </HeaderRow>

        <SearchInput
          placeholder="Buscar nivel..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <RoleListContainer>
          {filteredRoles.map((r) => (
            <RoleItem
              key={r.id}
              active={selectedRole?.id === r.id}
              onClick={() => selectRole(r)}
            >
              {/* IZQUIERDA: nombre y descripción */}
              <div style={{ display: "flex", flexDirection: "column" }}>
                <strong>{r.name}</strong>
                <div style={{ fontSize: 11, color: "#64748b" }}>
                  {r.description}
                </div>
              </div>

              {/* DERECHA: ícono */}
              <span
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setEditingRole(r);
                  setOpenModal(true);
                }}
              >
                ✏️
              </span>
            </RoleItem>
          ))}
        </RoleListContainer>
      </Left>

      {/* PANEL DERECHO */}
      <Right>
        <HeaderRow>
          <TreeHeader>
            <h3>Módulos del sistema</h3>

            <span style={{ cursor: "pointer" }} onClick={expandAll}>
              ▾
            </span>
          </TreeHeader>

          <BtnGeneral
            bg="green"
            padding="6px 10px"
            radius="6px"
            fw="600"
            onClick={savePermissions}
          >
            Guardar
          </BtnGeneral>
        </HeaderRow>

        <TreeContainer>
          {tree.map((node) => (
            <PermissionNode
              key={node.id_modulo}
              node={node}
              level={0}
              checked={checked}
              expanded={expanded}
              onToggleModule={toggleModule}
              onToggleAction={toggleAction}
              onToggleExpand={toggleExpand}
              parentStack={[]}
            />
          ))}
        </TreeContainer>
      </Right>

      {/* MODAL */}
      <ModalRole
        open={openModal}
        roleData={editingRole}
        onClose={() => setOpenModal(false)}
        onSave={async (data) => {
          const resp = await saveRoleData(data);

          if (!resp.success) {
            toast.error("Error guardando el nivel");
            return;
          }

          toast.success(data.id ? "Nivel actualizado" : "Nivel creado");

          await loadRoles();
          setOpenModal(false);
        }}
      />
    </Page>
  );
}
